/**
* Contains React app configuration for each child

* Main configuration:
* @param {string} name - the display name of the child
* @param {string} theme - slug for child theme
* @param {Boolean} multiLanguage - using eng/dutch (true) or only dutch (false)
* @param {Boolean} hide_on_home_desktop - by default this app shows on homepage, but most sites hide this on desktop
* @param {String} empty_agenda_text - text that is shown on empty state
* @param {String} loading_svg - name of svg used for loader ("Camera"/"KinoLoader" or null)

* Movie tile configuration
* @param {Boolean/String} showtime_undertitle - in movie tile, what is displayed underneath each show time (e.g. venue, room) or false for nothing
* @param {String} card_type - choose between two different designs, either "filmhallen" or "bioscopenleiden"
* @param {String} agenda_tile_type - choose between different designs: "small", "big", or "both" (for variation according to sort option)
* @param {String} big_title_agendatext - choose between "storyline" or "synopsis" (or null if no big tile)
* @param {Boolean} big_tile_date_short - use specific date view that only displays first letters of month/weekday (if in big tile)
* @param {Boolean} show_movie_info_in_tile - show director name, country, duration (if in big tile)
* @param {Boolean} show_movie_review_in_tile - show review (if in big tile)
* @param {Boolean} date_today_tomorrow_label - show "vandaag" and "morgen" labels instead of dates in case of today/tomorrow

* Filterbar configuration
* @param {Boolean} has_cinema_selector - in case of multiple locations/cinemas for one site, this feature can filter out specific cinema
* @param {Boolean} has_sorting_option - feature to manually switch/toggle between showing 1) movies sorted by popularity or 2) individual showtimes
* @param {Boolean} sorting_option_mobile_nonemodal - option for a second sorting toggle above filterbar on closed modal
* @param {Number} minimum_days_in_filter - amount of fixed days that are shown in dropdown even if they do not match a show
* @param {Array} no_special_tags - showtags from db that are excluded when finding "specials"
* @param {Array} tags_hide_from_dropdown - which tags are available for tiles but not for filter dropdown

* Tab configuration
* @param {Object} available_tabs - Object with tabs for this site featuring {slug: title} of the tab
* @param {String} special_tab_sorting - sort special tab movies by either "release-date" or popularity ("populair" )
* @param {String} special_tab_filtering - show all specials ("all-specials") or only those with showtimes ("only-with-times")

*/

window.customData = {
  childTheme: 'vorstin',

  i18n: {
    ee_cancel_confirmation: 'Weet u zeker dat u %s1 ticket(s) voor %s2 op %s3 wilt annuleren?',
    account_form_continue: 'Verder',
    account_form_back: 'Terug',
    account_choice: 'of',
    account_form_reset: 'Stuur login opnieuw',
    account_form_complete: 'Stuur login',
    account_form_title: 'Mijn tickets',
    account_form_title_alt: 'Bevestig inloggen in je mail',
    empty_agenda_text: 'Ons filmaanbod zien? Kies hierboven een datum en selecteer eventueel andere voorkeuren.',
    agenda_tab_now: 'Nu te zien',
    agenda_tab_kids: 'Kids',
    agenda_tab_specials: 'Specials',
    agenda_tab_expected: 'Verwacht',
    agenda_tab_all: 'Alle films',
    agenda_date_name: 'Datum',
    agenda_date_today: 'Vandaag',
    agenda_date_tomorrow: 'Morgen',
    agenda_date_all: 'Alle dagen', //werkt nog niet
    agenda_cinema_name: 'bioscoop',
    agenda_cinema_all: 'Alle bioscopen',
    agenda_tag_filter_name: 'filter',
    agenda_tag_filter_all: 'Alle filters',
    agenda_tag_filter_selected: 'filters geselecteerd',
    agenda_filter_choose: 'Kies',
    agenda_sort_option_movies: 'Films',
    agenda_sort_option_times: 'Tijden',
    agenda_delete_filters: 'Wis selectie',
    agenda_filter_button_mobile: 'Filteren',
    agenda_results_mobile_show: 'Toon',
    agenda_results_mobile_movie: 'film', //letter s is added by js
    movie_tile_director: 'Regisseur',
    movie_tile_country: 'Land',
    movie_tile_duration: 'Duur',
    agenda_tile_from: 'Vanaf',
    agenda_tile_tickets: 'Tickets & Tijden',
    agenda_tile_info: 'Meer info',
    agenda_show_soldout: 'UITVERKOCHT',
  },
};

const config = {
  vorstin: {
    name: 'vorstin',
    theme: 'vorstin',
    multiLanguage: true,
    hide_on_home_desktop: true,
    empty_agenda_text: customData.i18n.empty_agenda_text,
    loading_svg: 'Vorstin',
    showtime_undertitle: false,
    card_type: 'filmhallen',
    agenda_tile_type: 'big',
    big_title_agendatext: 'storyline',
    big_tile_date_short: false,
    show_movie_info_in_tile: true,
    show_movie_review_in_tile: true,
    has_cinema_selector: false,
    has_sorting_option: true,
    sorting_option_mobile_nonemodal: false,
    minimum_days_in_filter: 7,
    no_special_tags: ['2D', '3D', 'OV', 'NL'],
    tags_hide_from_dropdown: ['Special', 'Verwacht', 'Expected', 'Special no label'],
    available_tabs: {
      now: customData.i18n.agenda_tab_now,
      kids: customData.i18n.agenda_tab_kids,
      specials: customData.i18n.agenda_tab_specials,
      expected: customData.i18n.agenda_tab_expected,
      all: customData.i18n.agenda_tab_all,
    },
    special_tab_sorting: 'release-date',
    special_tab_filtering: 'only-with-times',
	 date_today_tomorrow_label: false,
  },
};

export default config;
